const normalizeFormat = (format) => {
  const value = String(format).trim().toLowerCase();
  if (!value || value.includes('/') || value.startsWith('.')) return value;
  return `.${value}`;
};

export const parseFormats = (formats = '') =>
  String(formats).split(',').map(normalizeFormat).filter(Boolean);

export const matchesFormats = (file, formats) => {
  const name = String(file?.name ?? '').toLowerCase();
  const type = String(file?.type ?? '').toLowerCase();

  return parseFormats(formats).some((format) => {
    if (format.endsWith('/*')) return type.startsWith(format.slice(0, -1));
    if (format.includes('/')) return type === format;
    return name.endsWith(format);
  });
};

export const unsupportedFilesAlert = (rejected, formats) => ({
  color: 'danger',
  title: `Can't add ${rejected.map(({ name }) => name).join(', ')}`,
  message: `Only ${parseFormats(formats).join(', ')} files can be uploaded here.`
});
